/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react'

class TimeSelector extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      selected: 2,
    }
    this.options = ['1 Week', '2 Weeks', '1 Month', '3 Months']
    this.intervals = [7, 14, 30, 90]
  }

  getValue() {
    return this.intervals[this.state.selected]
  }

  renderOptions() {
    return this.options.map((option, selected) => {
      const arr = option.split(' ')
      return (
        <div
          key={option}
          onClick={() => this.setState({
            selected,
          })}
          className={`uk-flex uk-flex-column  uk-flex-center uk-flex-middle uk-card ${selected === this.state.selected ? 'uk-card-primary' : 'uk-card-default'} uk-text-center uk-padding-small uk-card-hover uk-margin-left`}
          style={{
            cursor: 'pointer',
            width: 150,
          }}
        >
          <h5
            className="uk-margin-remove"
          >
            {arr[0]}
          </h5>
          <hr
            className="uk-align-center uk-margin-small"
            style={{ width: '50%' }}
          />
          <h5
            className="uk-margin-remove"
          >
            {arr[1]}
          </h5>
        </div>
      )
    })
  }

  render() {
    return (
      <div className="uk-flex uk-flex-row uk-margin-bottom uk-margin-top">
        {this.renderOptions()}
      </div>
    )
  }
}

export default TimeSelector
